function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOrderGuideStar = function SvgOrderGuideStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: props.fill,
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M6.5 7.5h3m-3 2h2.333M5.387 5.325l-3.389.497A.667.667 0 0 0 1.63 6.96l2.454 2.4a.67.67 0 0 1 .191.588l-.578 3.386c-.093.545.48.96.968.702L7.69 12.44a.67.67 0 0 1 .622 0l3.025 1.596a.667.667 0 0 0 .968-.702l-.578-3.386a.67.67 0 0 1 .19-.589l2.455-2.4A.667.667 0 0 0 14 5.823l-3.388-.497a.67.67 0 0 1-.502-.365L8.598 1.883a.667.667 0 0 0-1.196 0L5.889 4.96a.67.67 0 0 1-.502.365Z"
  }));
};
export default SvgOrderGuideStar;